import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "workspaceList"]

  toggle(event) {
    event.stopPropagation()
    if (this.panelTarget.classList.contains("hidden")) {
      this.workspaceListTarget.classList.add("hidden")
      this.panelTarget.classList.remove("hidden")
    } else {
      this.#close()
    }
  }

  toggleWorkspace(event) {
    event.stopPropagation()
    this.workspaceListTarget.classList.toggle("hidden")
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.#close()
  }

  #close() {
    this.panelTarget.classList.add("hidden")
    this.workspaceListTarget.classList.add("hidden")
  }
}
